import { PlayerDataTableList } from '../../../state/reduxRepositories/players/player.interfaces';
import { Order } from './playerTable.interface';

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  const aOrderBy = a[orderBy] as string;
  const bOrderBy = b[orderBy] as string;
  if (orderBy === 'playerName') {
    if (bOrderBy.toLowerCase() < aOrderBy.toLowerCase()) {
      return -1;
    }
    if (bOrderBy.toLowerCase() > aOrderBy.toLowerCase()) {
      return 1;
    }
  } else if (orderBy === 'rawDOB') {
    if (new Date(bOrderBy) < new Date(aOrderBy)) {
      return -1;
    }
    if (new Date(bOrderBy) > new Date(aOrderBy)) {
      return 1;
    }
  } else {
    if (bOrderBy < aOrderBy) {
      return -1;
    }
    if (bOrderBy > aOrderBy) {
      return 1;
    }
  }

  return 0;
}

export function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key,
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string },
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
export function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number,
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function createData(
  playerId: string,
  playerName: string,
  team: string,
  dob: string,
  rawDOB: string,
  clearStatus: boolean,
  conneqtedStatus: boolean,
  guardianEmail: string,
): PlayerDataTableList {
  return {
    playerId,
    playerName,
    team,
    dob,
    rawDOB,
    clearStatus,
    conneqtedStatus,
    guardianEmail,
  };
}
